<template>
	<div class="container">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<van-form>
			<div>
				<h2 class="van-form-title">生产状态</h2>
				<van-field v-model="status[form.status]" label="当前状态" readonly />
			</div>

			<h2 class="van-form-title">订单信息</h2>
			<van-field v-model="form.drawing_name" label="项目名称" readonly />
			<van-field v-model="form.client_name" label="单位名称" readonly />
			<van-field v-model="form.dr_code" label="生产编号" readonly />
			<van-field v-model="form.order_code" label="订单编号" readonly />
			<van-field v-model="order_type[form.order_type]" label="订单类型" readonly />

			<h2 class="van-form-title">商品详情</h2>
			<van-cell-group>
				<van-cell title="商品详情" value="点击查看商品详情" @click="productDetails" />
			</van-cell-group>
			<h2 class="van-form-title" v-if="auditBtn">订单详情</h2>
			<van-cell-group v-if="auditBtn">
				<van-cell title="订单详情" value="点击查看订单详情" @click="viewDetails" />
			</van-cell-group>
			<h2 class="van-form-title">下单信息</h2>
			<van-field v-model="form.user_name" label="下单人" readonly />
			<van-field v-model="form.initiate_date" label="下单时间" readonly />
			<van-field v-model="form.predict_date" label="交图时间" readonly />
			<van-field v-model="form.deliver_date" label="交货日期" readonly />
			<h2 class="van-form-title">图纸附件</h2>
			<van-cell-group>
				<div class="schedule" v-if="form.file_list != null">
					<!-- <p>附件列表</p> -->
					<div class="schedule-body">
						<div class="file-body">
							<div class="file-body-item" v-for="(item, index3) in file_list" :key="index3">
								<div class="img-body" v-if="isTypeImage(item.file_type)">
									<van-image width="100" height="100" :src="fileUrl + item.file_id"
										@click="imgLook(fileUrl + item.file_id)" />
								</div>
								<div class="img-body" v-else-if="isTypeMp4(item.file_type)"
									@click="lookVideo(fileUrl + item.file_id)">
									<i class="file-icon van-icon-description"></i>
									<div class="file-name">{{ item.file_name }}</div>
								</div>
								<div class="img-body" v-else-if="isType(item.file_type)"
									@click="lookfile(fileUrl + item.file_id)">
									<i class="file-icon van-icon-description"></i>
									<div class="file-name">{{ item.file_name }}</div>
								</div>
								<div class="img-body" v-else @click="clickFile">
									<i class="file-icon van-icon-description"></i>
									<div class="file-name">
										{{ item.file_name }}.{{ item.file_type }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-cell-group>
		</van-form>
		<van-popup v-model="videoShow" style="width: 100%" @close="closePanel">
			<video-player id="video" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
				:options="playerOptions"></video-player>
		</van-popup>
		<van-popup v-model="showPopup" style="width: 100%;height: 80%;" @opened="pdfpanel">
			<div class="m-pdf">
				<div id="pdf-content"></div>
			</div>
		</van-popup>
		<audit-btn v-if="auditBtn" @audit="auditcheck" v-bind:content="form"></audit-btn>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import auditBtn from "@/components/auditBtn/index";
import { post } from "@/api/order";
import { Toast } from "vant";
import global_url from "@/utils/global";
import { isImage, isMp4, istype } from "@/utils/tool";
import { ImagePreview } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
	components: {
		navbar,
		"audit-btn": auditBtn,
	},
	data() {
		return {
			title: "生产单详情",
			activeName: "index",
			id: this.$route.query.id,
			form: {},
			file_list: [],
			order_type: ["简易箱体", "防水箱体", "异形箱体", "E结构框架", "小间距箱体", "产品借用", "交安产品", "其它定制"],
			status: ["待制图", "制图中", "制图完成", "待排版", "排版中", "待生产", "生产中", "", "", "", "", "", "", "", "生产完毕待交货", "完成", "", "", "财务审核", "", "终止生产"],
			fileUrl: this.findUrl(),
			auditBtn: false,
			playerOptions: {
				autoplay: false,
				muted: false,
				preload: "auto",
				language: "zh-CN",
				aspectRatio: "16:9",
				fluid: true,
				sources: [
					{
						type: "video/mp4",
						src: "",
					},
				],
				notSupportedMessage: "此视频暂无法播放，请稍后再试",
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
				},
			},
			videoShow: false,
			showPopup: false,
			pdfUrl: "",
		};
	},
	mounted() {
		this.getDetails();
		if (this.$route.query.p && this.$route.query.p != "false") {
			this.auditBtn = true;
		}
	},
	methods: {
		getDetails() {
			post({
				requestType: "drawing_list_details",
				id: this.id,
			})
				.then((res) => {
					// console.log(res.obj.file_list.length);
					this.form = res.obj;
					if (res.obj.review_button == 0) {
						this.review_button = true;
					}
					if (res.obj.file_list.length != 0) {
						this.file_list = JSON.parse(res.obj.file_list);
					}
				})
				.catch((err) => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		productDetails() {
			if (this.form.order_id) {
				this.$router.push({
					path: "/order/productDetails",
					query: {
						id: this.form.order_id,
					},
				});
			} else {
				return Toast.fail("制图单无商品信息");
			}
		},
		// 订单详情
		viewDetails() {
			this.$router.push({
				path: "/order/details",
				query: {
					id: this.form.order_id,
					p: false
				}
			});
		},
		//提交审核
		auditcheck() {
			let curStatus = Number(this.form.status);
			let statusVal;
			// console.log("原始status值：", this.form.status, "转数字后：", curStatus);
			if (curStatus === 2) {
				statusVal = 18;
			} else if (curStatus === 18) {
				statusVal = 3;
			} else {
				statusVal = curStatus + 1;
			}
			// console.log("计算出来statusVal=", statusVal);
			let form = {
				requestType: "drawing_edit",
				dr_id: this.form.id,
				status: statusVal,
			};
			post(form)
				.then((res) => {
					if (res.code == 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-1);
						return Toast("审核成功");
					} else {
						return Toast(res.msg);
					}
				})
				.catch((res) => {
					return Toast.fail(res.msg);
				});
		},
		closePanel() {
			let video = document.getElementsByTagName("video")[0];
			video.pause();
		},
		lookVideo(url) {
			console.log(url);
			this.playerOptions.sources[0].src = url;
			this.videoShow = true;
		},
		pdfpanel() {
			//先实例化
			this.pdfh5 = new Pdfh5("#pdf-content", {
				pdfurl: this.pdfUrl,
				goto: 1,
				lazy: true,
			});
			this.pdfh5.scrollEnable(true);
		},
		lookfile(row) {
			this.showPopup = true;
			this.pdfUrl = row
			// console.log(row);

		},
		isTypeMp4(name) {
			console.log(name);
			return isMp4(name);
		},
		isType(name) {
			return istype(name);
		},
		isTypeImage(name) {
			return isImage(name);
		},
		findUrl() {
			return global_url.fileUrl;
		},
		imgLook(url) {
			ImagePreview({
				images: [url],
			});
		},
		clickFile() {
			return Toast.fail("暂不支持该文件查看");
		},
	},
};
</script>

<style lang="scss" scoped>
.container {
	padding-bottom: 30px;
}

.demo-panel .van-panel__footer {
	text-align: right;
}

.goods-panel {
	margin-top: 15px;
}

[class*="van-hairline"] {
	border: none;

	&+[class*="van-hairline"]:after {
		border: 0 solid #ebedf0;
	}
}

.input-right {
	display: flex;
	align-content: space-between;
	justify-items: center;

	.input-tag {
		display: flex;
		align-content: space-between;
		justify-items: center;
	}
}

.van-form-title {
	margin: 0;
	padding: 20px 16px 16px;
	color: rgba(69, 90, 100, 0.6);
	font-weight: normal;
	font-size: 14px;
	line-height: 16px;
}

.van-cell__value {
	color: #1989fa;
}

.m-pdf {
	// 保证pdf区域铺满整个屏幕
	// 方法1：使用vw和vh视窗单位，1vw=视窗宽度的1%；1vh=视窗高度的1%
	// width: 100vw;
	// height: 100vh;
	// 方法2：使用fixed定位
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}

.file-body {
	width: calc(100% + 10px);
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	.file-body-item {
		list-style: none;
		flex: 0 0 calc(33.33% - 10px);
		margin-right: 10px;
	}
}

.schedule {
	margin-top: 1px;
	margin-bottom: 12px;
	// padding-left:15px;
	margin-left: 20px;
	margin-right: 20px;

	// overflow: hidden;
	.file-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-top: 2px;

		&-item {
			position: relative;
			margin: 0 2px 2px 0;
			cursor: pointer;

			.img-body {
				display: block;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 8px;
				box-shadow: #ebedf0 0 4px 12px;
				text-align: center;

				img {
					object-fit: cover;
					display: block;
					width: 100%;
					height: 100%;
				}

				.file-icon {
					position: relative;
					display: inline-block;
					font: normal normal normal 14px/1 "vant-icon";
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					color: #646566;
					font-size: 20px;
					margin-top: 15px;
				}

				.file-name {
					box-sizing: border-box;
					width: 100%;
					margin-top: 4px;
					padding: 0 4px;
					color: #646566;
					font-size: 12px;
					text-align: center;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
			}
		}
	}
}
</style>
